var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',_vm._b({style:({ fontSize: '120%' }),attrs:{"href":"#"},domProps:{"textContent":_vm._s(_vm.text)}},'a',_vm.beaconArticleLink,false))}
var staticRenderFns = []

export { render, staticRenderFns }